
import ProgressSpinner from 'primevue/progressspinner';

export default {
  name: 'Login',
  components: {
    ProgressSpinner,
  },
};
